import styled from 'styled-components';
import Box, { BoxProps } from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';

import { WithMyTheme } from '@keaze/web/theme';

interface CustomBoxProps extends WithMyTheme {
  $checked?: boolean;
}

export const Card = styled(Box)<BoxProps & CustomBoxProps>`
  ${({
    theme: {
      palette,
      colors,
      breakpoints,
      transitions: { easing, duration },
    },
    $checked,
  }: CustomBoxProps) => `

    left: 0;
    cursor: pointer;
    width: 166px;
    height: 68px;

    box-shadow: ${$checked ?  '0px 3px 9px 0px rgba(0, 0, 0, 0.45) !important' : '' }  ;

    border: 1px solid ${colors.greens.green3};
    background-color: ${$checked ? palette.primary.main : colors.whites.white1};
    transition: ${duration.standard}ms ${easing.easeInOut};
    padding: 10px;
    &:hover {
      p {
      color: ${colors.whites.white1} !important;
      }
      background-color: ${
        $checked ? palette.primary.main : palette.action.hover
      };
    }

    ${breakpoints.up('md')} {
     
      width: 166px;
    }
  `}
`;

export const From = styled(Typography)`
  font-weight: 400;
  font-size: 18px;
  color: #003C3B;
  padding-right 1rem;
`;

export const Price = styled(Typography)`
  ${({ theme: { breakpoints } }) => `
    font-weight: 700;
    color: #003C3B;
    font-size: 18px;
    position: relative;
    bottom: 1.5rem;
    left: 2.8rem;
    padding-left: 0.5rem;
    ${breakpoints.up('md')} {
    }
  `}
`;

export const Bedrooms = styled(Typography)`
  ${({ theme: { breakpoints } }) => `
    font-weight: 400;
    font-size: 18px;
    color: #003C3B;
    position: relative;
    bottom: 1.5rem;
    left: 0;
    ${breakpoints.up('md')} {
    }
  `}
`;
